import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, viewChild } from '@angular/core';

import { IMAGE_KEYS, IMAGE_TO_PRINCIPE } from '@src/app-models';
import { AppStore } from '@src/app-store';

// Pour créer de nouveaux markers : importer une image et laisser les paramètres par défaut
// https://jeromeetienne.github.io/AR.js/three.js/examples/marker-training/examples/generator.html

@Component({
  imports: [],
  selector: 'app-ar-scene',
  templateUrl: './app-ar-scene.html',
  styles: ':host { display: contents; }',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppArScene {
  readonly store = inject(AppStore);
  readonly sceneContainer = viewChild('sceneContainer');

  readonly quests: IMAGE_KEYS[] = Object.keys(IMAGE_TO_PRINCIPE) as IMAGE_KEYS[];

  getQuestionFromQuest(quest: string) {
    this.store.drawQuestion(IMAGE_TO_PRINCIPE[quest as keyof typeof IMAGE_TO_PRINCIPE]);
  }
}
